import { useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { getGuestSocietyPreference } from '../utils/guestSocietyPreference';
import { shouldShowGuestWelcome } from './mainPageSocietyGate.utils';

export const STORAGE_GUEST_WELCOME_DISMISSED = 'main_guest_welcome_dismissed';

/**
 * Main page (/): guest welcome, missing-society prompt, and guest society preference.
 * Authenticated users with a society stay on the home page; they can open their society via the home banner.
 */
export function useMainPageSocietyGate() {
  const { user, isAuthenticated, isLoading, isValidating, fetchUserData } = useAuth();
  const ready = !isLoading && !isValidating;
  const hasSociety = !!(user?.society && (user.society.slug || user.society.id));
  const guestSocietyPreference = useMemo(() => {
    if (!ready || isAuthenticated) return null;
    return getGuestSocietyPreference();
  }, [ready, isAuthenticated]);
  const hasGuestSocietyPreference = !!guestSocietyPreference;

  const showGuestWelcome = shouldShowGuestWelcome();
  const showMissingSocietyPrompt = ready && isAuthenticated && !hasSociety;

  return {
    ready,
    showGuestWelcome,
    showMissingSocietyPrompt,
    fetchUserData,
    hasSociety,
    guestSocietyPreference,
    hasGuestSocietyPreference,
    isAuthenticated,
    userSociety: user?.society ?? null,
  };
}
